import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { getApiBase } from '../config/api';
import '../styles/admin.css';

// --- Reusable Components ---
const Message = ({ text, type }) => {
  if (!text) return null;
  return <div className={`alert alert-${type} mt-2`}>{text}</div>;
};

const ManageQuotes = () => {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Fetch quotes from API
  const fetchQuotes = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${getApiBase()}/api/quotes`);
      setQuotes(res.data);
      setError('');
    } catch (err) {
      setError('Failed to load quotes.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchQuotes();
  }, [fetchQuotes]);

  // Handle Delete
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this quote request?')) {
      try {
        await axios.delete(`${getApiBase()}/api/quotes/${id}`);
        // Remove from UI immediately
        setQuotes(prev => prev.filter(q => q.id !== id));
      } catch (err) {
        alert('Failed to delete quote.');
      }
    }
  };

  if (loading) {
    return (
      <div className="container py-5 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-5">
      <h1 className="display-4 fw-bold mb-3 admin-dashboard-title">Manage Quote Requests</h1>
      
      {error && <Message text={error} type="danger" />}

      <div className="admin-card">
        <div className="card-body">
          {quotes.length === 0 ? (
            <p className="text-muted text-center py-5">No quote requests found.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-striped align-middle">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Name</th>
                    <th>Business</th>
                    <th>Phone</th>
                    <th>Email</th>
                    <th>Details</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {quotes.map((quote) => (
                    <tr key={quote.id}>
                      <td style={{whiteSpace: 'nowrap'}}>
                        {new Date(quote.date || quote.submittedAt).toLocaleDateString()}
                      </td>
                      <td className="fw-bold">{quote.name}</td>
                      <td>{quote.business}</td>
                      <td>{quote.phone}</td>
                      <td>
                        <a href={`mailto:${quote.email}`}>{quote.email}</a>
                      </td>
                      <td>
                         {/* Display message in a truncated way or tooltip */}
                         <div style={{maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} title={quote.message}>
                           {quote.message}
                         </div>
                      </td>
                      <td>
                        <button 
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(quote.id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ManageQuotes;